<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">FAQs</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a href="javascript:void(0);">FAQs</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="about-institute ptb--100">
  <div class="container">
    <div class="row justify-content-center align-items-center">
      <div class="col">
        <div class="accordion accordian-class" id="accordionExample1">
          <div class="accordion-item">
            <h2 class="accordion-header accordion-button" id="headingOne" data-bs-toggle="collapse"
              data-bs-target="#bcom" aria-expanded="true" aria-controls="collapseOne">
              B.Com
            </h2>
            <div id="bcom" class="accordion-collapse collapse show" aria-labelledby="headingOne"
              data-bs-parent="#accordionExample1">
              <div class="accordion-body">
                <div class="row justify-content-center align-items-center">
                  <div class="col-xs-12 col">
                    <h4 class="yellow-color mb-2">First Year</h4>
                    <ul class="list-before">
                      <li><a href="https://drive.google.com/file/d/1TZdhfbbk0yfEg5LBL7BDzP2SMTMOxbKJ/view?usp=sharing"
                          target="_blank" class="text-dark">F.Y.B.COM ( 2013 PATTERN ) April 2018</a></li>
                      <li><a href="https://drive.google.com/file/d/14idLk4972S8YKa_OoicyltElGhgNWRj4/view?usp=sharing"
                          target="_blank" class="text-dark">F.Y.B.COM ( 2013 PATTERN ) Oct 2018</a></li>
                      <li><a href="https://drive.google.com/file/d/1up9kuD8RFydQjCR7WNgmtw0Z3Rz2H6b0/view?usp=sharing"
                          target="_blank" class="text-dark">F.Y.B.COM ( 2013 PATTERN ) April 2019</a></li>
                    </ul>
                  </div>
                  <div class="col-xs-12 col">
                    <h4 class="yellow-color mb-2">Second Year</h4>
                    <ul class="list-before">
                      <li><a href="https://drive.google.com/file/d/1wnJKKW9IOuxlneo-ZaxU_APZAH2Y2GDp/view?usp=sharing"
                          target="_blank" class="text-dark">S.Y.B.COM ( 2013 PATTERN ) April 2018</a></li>
                      <li><a href="https://drive.google.com/file/d/15vG70c2F6KzXYrFrtpQBQ2Cl4JGuuBIU/view?usp=sharing"
                          target="_blank" class="text-dark">S.Y.B.COM ( 2013 PATTERN ) Oct 2018</a></li>
                      <li><a href="https://drive.google.com/file/d/1QhN3feFh1rfQw3VSTsmXnl_Jpc2r3vEs/view?usp=sharing"
                          target="_blank" class="text-dark">S.Y.B.COM ( 2013 PATTERN ) April 2019</a></li>
                    </ul>
                  </div>
                  <div class="col-xs-12 col">
                    <h4 class="yellow-color mb-2">Third Year</h4>
                    <ul class="list-before">
                      <li><a href="https://drive.google.com/file/d/1RKTnOGC1aGxHC-aRgUHC9-4VWfxLd7e5/view?usp=sharing"
                          target="_blank" class="text-dark">T.Y.B.COM ( 2013 PATTERN ) April 2018</a></li>
                      <li><a href="https://drive.google.com/file/d/1K3bunOT3sm6bgMis_jrtniJ5HwDjMs1-/view?usp=sharing"
                          target="_blank" class="text-dark">T.Y.B.COM ( 2013 PATTERN ) Oct 2018</a></li>
                      <li><a href="https://drive.google.com/file/d/1TXRFcPL0NQZ_8r5EYsJHY9-1EGchbL15/view?usp=sharing"
                          target="_blank" class="text-dark">T.Y.B.COM ( 2013 PATTERN ) April 2019</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="accordion-item">
            <h2 class="accordion-header accordion-button" id="headingOne" data-bs-toggle="collapse"
              data-bs-target="#bsc" aria-expanded="true" aria-controls="collapseOne">
              B.Sc
            </h2>
            <div id="bsc" class="accordion-collapse collapse show" aria-labelledby="headingOne"
              data-bs-parent="#accordionExample1">
              <div class="accordion-body">
                <ul class="list-before">
                  <li><a href="https://drive.google.com/file/d/1gWpw4JpdNZ58iix20GxoYA11nY_vU86F/view?usp=sharing"
                      target="_blank" class="text-dark">B.Sc October 2018</a></li>
                  <li><a href="https://drive.google.com/file/d/1GFuZEgxpqAvf1EdFfrug5GbuJ2tsFdHT/view?usp=sharing"
                      target="_blank" class="text-dark">B.Sc April 2019</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
